import { TeamQuiz } from "./-components/teamQuiz"
import { IndividualQuiz } from "./-components/individualQuiz"
import { ChampionsQuiz } from "./-components/championsQuiz"
import { api } from "@convex/_generated/api"
import type { Id } from "@convex/_generated/dataModel"
import { createFileRoute } from "@tanstack/react-router"
import { useQuery } from "convex/react"

export const Route = createFileRoute("/(app)/app/quizzes/$quizStateId/")({
  component: RouteComponent,
})

function RouteComponent() {
  const { quizStateId } = Route.useParams()

  // Fetch quiz state by ID (includes quiz details)
  const data = useQuery(api.quizState.handlers.getQuizStateById, {
    quizStateId: quizStateId as Id<"quizState">,
  })

  if (!data) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    )
  }

  const { quizState, quiz } = data

  // Check if this is a team quiz
  const isTeamQuiz = quiz.type === "teams" || quiz.type === "pairs"

  // If team quiz, render team quiz component
  if (isTeamQuiz) {
    return <TeamQuiz quiz={quiz} quizState={quizState} />
  }

  const isChampionsQuiz = quiz.type === "champions"
  if (isChampionsQuiz) {
    return <ChampionsQuiz quiz={quiz} quizState={quizState} />
  }

  const isIndividualQuiz = quiz.type === "daily" || quiz.type === "specialist"
  if (isIndividualQuiz) {
    return <IndividualQuiz quiz={quiz} quizState={quizState} />
  }

  // Fallback for unknown quiz types
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-muted-foreground">Unknown quiz type</div>
    </div>
  )
}
